<template>
  <div class="flex h-screen admin-layout ">
    <!-- Sidebar -->
    <Sidebar :role="role" :collapsed="collapsed" :mobileOpen="mobileSidebarOpen" :isDesktop="isDesktop"
      @close-mobile="closeMobileSidebar" />

    <!-- Main Content -->
    <div class="flex flex-column flex-1 min-w-0 transition-all duration-300 ease-in-out"
      :class="[isDesktop ? (collapsed ? 'md:ml-6rem' : 'md:ml-16rem') : '']">
      <!-- Top Bar -->
      <Topbar :role="role" :collapsed="collapsed" :isDesktop="isDesktop" @toggle-sidebar="toggleSidebar"
        @toggle-mobile="toggleMobileSidebar">
        <template #search>
          <slot name="topbar-search">
            <!-- <div class="flex flex-column ">
              <IconField>
                <InputIcon class="pi pi-search" />
                <InputText v-model="globalSearchValue" placeholder="Search by keywords..." size="small" />
              </IconField>
            </div> -->
          </slot>
          <div class="flex flex-column align-items-start">
            <span class="Label role-avatar">{{ role === 'super_admin' ? 'SA' : 'A' }}</span>
          </div>
          <div class="flex flex-column align-items-start">
            <span class="Label pb-1">{{ userName }}</span>
            <small class="Caption align-self-end text-right" style="font-size: 0.65rem">{{ formattedRole }}</small>
          </div>
        </template>
      </Topbar>

      <!-- Content -->
      <main class="content-area transition-all duration-300">
        <div class="container-custom mx-auto pt-0">
          <div class="flex flex-wrap justify-content-between pb-4">
            <slot name="header">
              <Breadcrumb />
              <Button label="Export" class="accent-button" />
            </slot>
          </div>
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import Sidebar from "@/components/dashboard/admin/SideBar.vue";
import Topbar from "@/components/dashboard/admin/TopBar.vue";
import Breadcrumb from "@/components/CustomBreadcrumb.vue"
import Button from 'primevue/button';
import { useAuthStore } from "@/stores/authStore";

const authStore = useAuthStore();
const collapsed = ref(false);
const mobileSidebarOpen = ref(false);
const isDesktop = ref(window.innerWidth >= 768);
const role = computed(() => authStore.user?.role || "");
const formattedRole = computed(() => role.value.replace(/_/g, " ").toUpperCase());
const userName = computed(() => authStore.user?.username)

const toggleSidebar = () => {
  if (isDesktop.value) collapsed.value = !collapsed.value;
};

const toggleMobileSidebar = () => {
  if (!isDesktop.value) mobileSidebarOpen.value = !mobileSidebarOpen.value;
};

const closeMobileSidebar = () => {
  mobileSidebarOpen.value = false;
};

const handleResize = () => {
  isDesktop.value = window.innerWidth >= 768;
  if (isDesktop.value) mobileSidebarOpen.value = false;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));

</script>

<style scoped>
.admin-layout {
  background-color: var(--black-600) !important;
}

.role-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border: 1px solid var(--gray-700);
  border-radius: 50%;
}

.transition-all {
  transition-property: all;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
}

.content-area {
  margin: 18px;
  border-radius: 8px;
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 10vh);
}

.container-custom {
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  min-height: 50vh;
}
</style>
